import { memo, useEffect, useRef, useState } from 'react'

import { Down, Up } from '@icon-park/react'
import {
  Wrapper,
  SelectionContainer,
  DropdownContainer,
  DropdownOption,
} from './PublisherPersonsPlatformSelector.style'

const PLATFORMS = ['Twitter', 'Instagram', 'Facebook', 'YouTube']

type Props = {
  value: string
  onChange: (value: string) => void
}

export const PlatformSelector = memo(function PlatformSelector({ value, onChange }: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  function handleSelect(platform: string): void {
    onChange(platform)
    setIsOpen(false)
  }

  return (
    <Wrapper ref={ref}>
      <SelectionContainer onClick={() => setIsOpen((prev) => !prev)}>
        <span>{value}</span>
        {isOpen ?
          <Up size={12} />
        : <Down size={12} />}
      </SelectionContainer>
      {isOpen && (
        <DropdownContainer>
          {PLATFORMS.map((platform) => (
            <DropdownOption
              key={platform}
              $active={platform === value}
              onMouseDown={(e) => {
                e.preventDefault()
                handleSelect(platform)
              }}>
              {platform}
            </DropdownOption>
          ))}
        </DropdownContainer>
      )}
    </Wrapper>
  )
})
